import React from 'react';

import { Link } from 'react-router-dom';

import { UiButton } from '../../ui/ui-button';
import * as WebRoutes from '../../web-routes';
import { ReactComponent as MessageEmptyStateIllustration } from '../messages-empty-state.svg';

export const EmployeeMessagesEmptyState = ({
  orgId,
  handleNewMessageToggle,
}: {
  orgId: number;
  handleNewMessageToggle: () => void;
}) => (
  <div className="u-maxWidth-550px u-height-100 u-padding u-textAlign-center u-margin-0Auto u-display-flex u-justifyContent-center u-flexDirection-column u-alignItems-center">
    <div className="u-maxWidth-350px u-width-100 u-display-inlineBlock">
      <MessageEmptyStateIllustration />
    </div>
    <div className="typo-title u-margin-top-2x u-margin-bottom-2x">
      Welcome to employee messaging! From here you can have conversations with your workforce -
      whether that&apos;s about benefits, coordinating shifts, or following up on any payroll
      issues. If you want to communicate with a group of your employees, you can send them an
      <Link to={WebRoutes.employeeAnnouncementsRoute(orgId)} className="typo-link">
        {' '}
        Announcement{' '}
      </Link>
      or ask them a question using
      <Link to={WebRoutes.surveysRoute(orgId, null)} className="typo-link">
        {' '}
        Surveys
      </Link>
      .
    </div>
    <UiButton onClick={handleNewMessageToggle}>Get Started, Send A Message</UiButton>
  </div>
);
